import { createTreeContext, TREE_CONTEXT_KEY } from './tree-context'
import TreeNode from './tree-node'
import './index.scss'

export default {
  name: 'Tree',
  components: { TreeNode },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    keyField: {
      type: String,
      default: 'id'
    },
    childrenField: {
      type: String,
      default: 'children'
    },
    labelField: {
      type: String,
      default: 'label'
    },
    checkStrategy: { // 勾选策略：'all' 展示全部，'parent' 只展示父节点，'child' 只展示子节点
      type: String,
      default: 'all', // 'all', 'parent', 'child'
    },
    group: {
      type: Boolean,
      default: true //
    },
    renderContent: Function
  },
  provide() {
    return {
      [TREE_CONTEXT_KEY]: this.treeContext
    }
  },
  data() {
    return {
      treeContext: createTreeContext()
    }
  },
  watch: {
    data: {
      handler(val) {
        this.treeContext.updateStore(val)
      }
    }
  },
  created() {
    this.treeContext.init(this)
  },
  beforeDestroy() {
    this.treeContext.$destroy()
  },
  methods: {
    setCheckedKeys(keys) {
      this.treeContext.setCheckedKeys(keys)
    },
    // checkStrategy: 'all', 'parent', 'child'
    getCheckedKeys(checkStrategy) {
      return this.treeContext.getCheckedKeys(checkStrategy).checkedKeys
    },
    getCheckedNodes(checkStrategy) {
      return this.treeContext.getCheckedNodes(checkStrategy)
    }
  },
  render(h) {
    const { flattenedNodes } = this.treeContext
    return (
      <div class="layout-tree">
        {flattenedNodes.map(item => (
          <TreeNode key={item.key} tmNode={item} renderContent={this.renderContent} />
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layout/components/tree/index.js